import { createGlobalStyle } from 'styled-components'

import { useAppTheme } from '../hooks/useAppTheme'

interface ThemeStylesProps {
  theme: ReturnType<typeof useAppTheme>;
}

const ThemeStyles = createGlobalStyle<ThemeStylesProps>`
  :root {
    /* Основные цвета */
    --color-primary: ${({ theme }) => theme.colors.primary};
    --ant-color-primary: ${({ theme }) => theme.colors.primary};
    --color-secondary: ${({ theme }) => theme.colors.secondary || theme.colors.primary};
    --color-accent: ${({ theme }) => theme.colors.accent || '#E6CCFF'};
    --color-background: ${({ theme }) => theme.colors.background || '#F5F5F5'};
    --color-surface: ${({ theme }) => theme.colors.surface || '#FFFFFF'};
    --border-color-secondary: ${({ theme }) => theme.colors.colorBorderSecondary || '#F0F0F0'};
    
    /* Ant Design переменные */
    --ant-color-primary-bg: ${({ theme }) => theme.colors.colorPrimaryBg || '#F9F0FF'};
    --ant-color-primary-bg-hover: ${({ theme }) => theme.colors.colorPrimaryBgHover || '#F8F0FF'};
    --ant-color-primary-border: ${({ theme }) => theme.colors.colorPrimaryBorder || '#E6CCFF'};
    --ant-color-primary-border-hover: ${({ theme }) => theme.colors.colorPrimaryBorderHover || '#C99EF7'};
    --ant-color-primary-hover: ${({ theme }) => theme.colors.colorPrimaryHover || '#A871EB'};
    --ant-color-primary-active: ${({ theme }) => theme.colors.colorPrimaryActive || '#6532B8'};
    --ant-color-primary-text-hover: ${({ theme }) => theme.colors.colorPrimaryTextHover || '#A871EB'};
    --ant-color-primary-text: ${({ theme }) => theme.colors.colorPrimaryText || theme.colors.primary};
    --ant-color-primary-text-active: ${({ theme }) => theme.colors.colorPrimaryTextActive || '#6532B8'};
    
    /* Дополнительные цвета для UI */
    --color-white: #FFFFFF;
    --color-black: #000000;
    --color-gray-50: #FAFAFA;
    --color-gray-100: #F5F5F5;
    --color-gray-200: #EEEEEE;
    --color-gray-300: #E0E0E0;
    --color-gray-400: #BDBDBD;
    --color-gray-500: #9E9E9E;
    --color-gray-600: #757575;
    --color-gray-700: #616161;
    --color-gray-800: #424242;
    --color-gray-900: #212121;
    
    /* Цвета для статусов */
    --color-success: #52C41A;
    --color-warning: #FAAD14;
    --color-error: #FF4D4F;
    --color-info: #1890FF;
    
    /* Цвета для темной темы */
    --color-dark-bg: #141414;
    --color-dark-surface: #1F1F1F;
    --color-dark-border: #424242;
    --color-dark-text: #FFFFFF;
    --color-dark-text-secondary: rgba(255, 255, 255, 0.85);
    --color-dark-text-disabled: rgba(255, 255, 255, 0.45);
    
    /* Тени */
    --shadow-1: 0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);
    --shadow-2: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
    --shadow-3: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px 0 rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);
  }
`

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const theme = useAppTheme()

  return (
    <>
      <ThemeStyles theme={theme} />

      {children}
    </>
  )
}
